import "./App.css";
import NavBar from "./component/NavBar";
import BodyContent from "./component/BodyContent";
// import Footer from "./component/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Terms from "./component/Terms";
import Policy from "./component/Policy";
import ThankYouScreen from "./component/ThankYouScreen";
import Lodha from "./projects/Lodha";
import Raheja from "./projects/Raheja";
import Chatbot from "./component/Chatbot"
import LnT from "./projects/LnT";
import Rustomjee from "./projects/Rustomjee";
import Raghav from "./projects/Raghav"
import Raymond from "./projects/Raymond";

const App = () => {
  return (
    <Router>
      <MainApp />
    </Router>
  );
};

const MainApp = () => {
  // const location = useLocation();

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<BodyContent />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
        <Route path="/lodha-projects" element={<Lodha />} />
        <Route path="/raheja-projects" element={<Raheja />} />
        <Route path="/lnt" element={<LnT />} />
        <Route path="/rustomjee" element={<Rustomjee />} />
        <Route path="/raghav" element={<Raghav />} />
        <Route path="/raymond" element={<Raymond />} />
      </Routes>
      <Chatbot />
      {/* {location.pathname !== "/thank-you" && location.pathname !== "/lodha-projects" && location.pathname !== "/raheja-projects" && <Footer />} */}
    </>
  );
};
export default App;
